module.exports = __webpack_public_path__ + "static/media/landing@2x.8e9a9f20.webm";